import { AppStorage } from './index';
import { ResponseType } from '../types/index';
import { __API as API } from 'data/api';
import { __PATH as PATH } from 'data/path';
import { Modal } from 'antd';
import { COLORS } from 'utilities';
export const SERVER = process.env.NEXT_PUBLIC_API_URL;

// class PromiseLike<T> {
//     private successFunc: (e: ResponseType<T>) => void = () => {};
//     private errorFunc: (e: ResponseType<any>) => void = () => {};
//     private finallyFunc: () => void = () => {};
//     private badRequestFunc: (e: ResponseType<any>) => void = () => {};
//     private unauthorizedFunc: (e: ResponseType<any>) => void = () => {};
//     private forbidenFunc: (e: ResponseType<any>) => void = () => {};
//     private notFoundFunc: (e: ResponseType<any>) => void = () => {};
//     private serverErrorFunc: (e: ResponseType<any>) => void = () => {};
//     private toManyRequestFunc: (e: ResponseType<any>) => void = () => {};
//     private unsupportedMediaFunc: (e: ResponseType<any>) => void = () => {};
//     private urlTooLongFunc: (e: ResponseType<any>) => void = () => {};
//     private badGatewayFunc: (e: ResponseType<any>) => void = () => {};
//     private gatewayTimeoutFunc: (e: ResponseType<any>) => void = () => {};
//     private networkErrorFunc: (e: ResponseType<any>) => void = () => {};

//     constructor(e: (handler: (status: number, data: any) => void) => void) {
//         e((status, data) => {
//             if (status >= 200 && status < 300) {
//                 this.successFunc(data);
//             } else {
//                 this.errorFunc({ status, data });
//                 if (status === 400) this.badRequestFunc(data);
//                 else if (status === 401) this.unauthorizedFunc(data);
//                 else if (status === 403) this.forbidenFunc(data);
//                 else if (status === 404) this.notFoundFunc(data);
//                 else if (status === 500) this.serverErrorFunc(data);
//                 else if (status === 429) this.toManyRequestFunc(data);
//                 else if (status === 415) this.unsupportedMediaFunc(data);
//                 else if (status === 414) this.urlTooLongFunc(data);
//                 else if (status === 502) this.badGatewayFunc(data);
//                 else if (status === 504) this.gatewayTimeoutFunc(data);
//                 else if (!status) this.networkErrorFunc(data);
//             }
//             this.finallyFunc();
//         });
//     }
// }

// add authentication headers to other headers
function generateHeader(object: any = {}): any {
    const header: { [k: string]: any } = {};
    if (AppStorage.authToken.get()) {
        header['Authorization'] = 'Bearer ' + AppStorage.authToken.get()?.access;
    }
    // add other headers
    for (const key of Object.keys(object)) {
        header[key] = object[key];
    }
    return header;
}

function unAuthorizedHandler() {
    if (AppStorage.authToken.get()?.access.length) {
        Modal.warning({
            title: 'خطا',
            content:
                'زمان انقضا ورود شما به پایان رسیده و شما به صورت خودکار از حساب کاربری خود خارج شده اید. لطفا مجددا وارد حساب کاربری خود شوید.',
            onOk: () => {
                window.location.href = PATH.login(window.location.pathname);
            },
            styles: {
                content: {
                    color: COLORS.gray1,
                },
            },
            okText: 'ورود مجدد',
            cancelText: 'بستن',
        });
    }
    AppStorage.authToken.remove();
    fetch(API.middlewares.logout, { method: 'POST' });
}

// delete request
function del(url: string): Promise<ResponseType<null>> {
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'DELETE',
            headers: generateHeader({ 'Content-Type': 'application/json' }),
        })
            .then(function (response) {
                status = response.status;
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data: null, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

// post request
function post<R>(url: string, body: any): Promise<ResponseType<R>> {
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: generateHeader({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(body),
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

// form request (not post, like html form submit)
function form<R>(url: string, body: any): Promise<ResponseType<R>> {
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            body: body,
            headers: generateHeader(),
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

// put request
function put<R>(url: string, body: any): Promise<ResponseType<R>> {
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: generateHeader({ 'Content-Type': 'application/json' }),
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

// patch request
function patch<R>(url: string, body: any): Promise<ResponseType<R>> {
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: generateHeader({ 'Content-Type': 'application/json' }),
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

export function upload<R>(URL: string, body: any, onProgress?: (progress: number) => void): Promise<ResponseType<R>> {
    // let abort: any;
    const formData = new FormData();
    const keys = Object.keys(body);
    for (let i = 0; i < keys.length; i++) formData.set(keys[i], body[keys[i]]);
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        // abort = request.abort;
        request.upload.addEventListener('progress', function (e) {
            if (onProgress) onProgress(e.loaded);
        });
        request.open('post', URL);
        request.onload = function () {
            if (request.readyState == XMLHttpRequest.DONE)
                resolve({ status: request.status, data: JSON.parse(request.responseText) });
            else reject({ status: request.status, data: null });
        };
        request.onerror = () => reject({ status: request.status, data: null });
        const token = AppStorage.authToken.get();
        if (token) request.setRequestHeader('Authorization', 'Bearer ' + token.access);
        request.timeout = 45000;
        request.send(formData);
    });
}

// get request
function get<R>(url: string, params: { [k: string]: any } = {}): Promise<ResponseType<R>> {
    const generatedUrl = new URL(url);
    // add query parameters like filters or pagination parameters
    Object.keys(params).forEach((key) => {
        generatedUrl.searchParams.append(key, params[key]);
    });
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(generatedUrl.href, {
            method: 'GET',
            headers: generateHeader({ 'Content-Type': 'application/json' }),
            next: { revalidate: 0 },
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ data, status });
                else {
                    if ([401].includes(status)) unAuthorizedHandler();
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

// validate if request was successful
function responseValidator(status: number): boolean {
    return status >= 200 && status < 300;
}

export const __RestAPI = {
    get,
    post,
    put,
    patch,
    form,
    delete: del,
    upload,
};
